import React from 'react'
import bigDecimal from 'js-big-decimal'
import moment from "moment";

export function getFileExtension(fileName) {
  const split = fileName.split('.')
  return split.length > 1 ? split.pop() : ''
}

export function truncate(text, maxTextLength) {
  let originalLength = text.length
  if (originalLength > maxTextLength) {
    return text.slice(0, maxTextLength - 6) + '...'
  }
  return text
}

export const triggerFormSubmit = (formRef) => () => {
  if (formRef.current) {
    formRef.current.handleSubmit()
  }
}

export function parseCoordinates(text) {
  const segments = text.split(',')
  if (segments.length === 2) {
    const numbers = segments.map(s => Number.parseFloat(s))
    const isEachSegmentNumber = numbers.every(n => !isNaN(n))
    if (isEachSegmentNumber) {
      const lat = numbers[0]
      const lng = numbers[1]
      if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
        return [lat, lng]
      }
    }
  }
  return null
}

export function toMicroDegrees(degrees) {
  const multiplier = new bigDecimal(1_000_000)
  return new bigDecimal(degrees)
    .round(6, bigDecimal.RoundingModes.HALF_UP)
    .multiply(multiplier)
    .getValue()
}

export function parsePrice(price) {
  return price ? `${price.amount} ${price.currencyCode}` : '―'
}

export function mapChildrenWithProps(children, props) {
  return React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...props,
        ...child.props
      })
    }
    return child
  })
}

export function containsAll(subset, superset) {
  return subset.every(item => superset.includes(item))
}

export function containsAny(subset, superset) {
  return subset.some(item => superset.includes(item))
}

export function dateExpired(date, compareDate, endOfDay) {
  if (!date) {
    return true
  }
  let validTill = moment(date)
  if (endOfDay) {
    validTill = validTill.endOf("day")
  }
  const diff = validTill.diff(compareDate ? compareDate : moment())
  return diff < 0
}
